module.exports = {
    tag: 'warm',
    quality: 0.2,
    willpower: 1,
    regeneration: 0.5
};